export default {
  getNewsList: function () {
    return [
      {
        newsId: 0,
        header: 'กิจกรรม Reflection ของนักเรียนชั้นม.6 รุ่น 10',
        src: 'newsData/0/thumbnail.jpg',
        type: 'กิจกรรม',
        data: 'activity',
        timeFormat: '18-08-2019',
        time: '18 ส.ค. 62',
        detail: 'เป็นกิจกรรมส่งเสริมการทบทวนการเรียนรู้และการเชื่อมโยงของนักเรียนตามหลักสูตร Story based learning ในช่วงเวลาประมาณ 1 เดือน',
        headerImg: 'newsData/0/images/header.jpg',
        fullDetail: [
          'กิจกรรม Reflection ของนักเรียนชั้นม.6 รุ่น 10',
          'เป็นกิจกรรมส่งเสริมการทบทวนการเรียนรู้และการเชื่อมโยงของนักเรียนตามหลักสูตร Story based learning ในช่วงเวลาประมาณ 1 เดือน ดังนั้นจะจัดขึ้นเดือนละ 1 ครั้ง \n' +
          'และมีรูปแบบแตกต่างกันไป ตามที่ทีมอาจารย์คิดว่าเหมาะสมกับช่วงเวลานั้นมากที่สุด',
          'สมาชิกแต่ละกลุ่มจะคละห้อง E S C ห้องละประมาณ 1-2 คน รวมสมาชิกในกลุ่ม 4-6 คน โดยในเดือนนี้ทางทีมอาจารย์ได้คิดโจทย์ให้นักเรียนได้ประลองปัญญาและรวบรวมสิ่งที่ได้เรียนมาในช่วงเดือนนี้มานำเสนอให้ทุกคนชมค่ะ \n' +
          'ใช้เวลาทำกิจกรรมตั้งแต่ 14.00-16.00 น. รวม 2 ชม.',
          '<b>โจทย์</b>',
          '1. Lesson learn นักเรียนได้เรียนรู้ หรือได้ทักษะอะไรเพิ่มเติมจากการทำโปรเจคไวน์ และการเรียนโปรเจคในวิชาเลือกเช่น Hands on, Research, Design เพื่อทบทวนตัวเอง',
          '2. ให้กลุ่มของนักเรียนคิดค้นนวัตกรรมเปลี่ยนโลก Innovation change the world ซึ่งมีตัวอย่างไอดอลคือ Nicola Tesla และ Thomas Alva Edison สองท่านนี้ครั้งหนึ่งเคยต่อสู้กันเรื่องไฟฟ้ากระแสตรงและไฟฟ้ากระแสสลับ \n' +
          'ซึ่งตอนนี้ทุกท่านก็คงทราบดีว่าใครเป็นผู้ชนะ หลายๆ ครั้งนวัตกรรมเกิดขึ้นจากความขัดแย้ง ความไม่ชอบในสิ่งที่เราเป็นอยู่ (contradiction, conflict,...) \n' +
          'การเปลี่ยนแปลงในครั้งนั้นทำให้โลกตอนนี้สว่างไสวได้ตลอดเวลาในราคาที่ถูกมาก...แล้วเด็กๆ ของเราเขาอยากจะเปลี่ยนอะไรบ้าง เปลี่ยนอย่างไรดี และจะทำออกมาได้จริงแค่ไหน \n' +
          'ถ้าทำออกมาได้โลกจะเปลี่ยนไปอย่างไร ทำไมต้องเปลี่ยน...ลองมาฟังกันดูค่ะ ว่าเด็กๆ จะคิดไอเดียอะไรมานำเสนอพวกเราบ้าง'
        ],
        imgSet: [
        ]
      },
      {
        newsId: 1,
        header: 'เปิดรับสมัครนักเรียนที่กำลังจะเรียนจบชั้นมัธยมศึกษาปีที่ 3',
        src: 'newsData/1/thumbnail.jpg',
        type: 'ข่าว',
        data: 'news',
        timeFormat: '26-08-2019',
        time: '26 ส.ค. 62',
        detail: 'โครงการ วมว. สำนักงานห้องเรียนวิศว์-วิทย์ มจธ. เปิดรับสมัครนักเรียนที่กำลังจะเรียนจบชั้นมัธยมศึกษาปีที่ 3 ในปีการศึกษา 2562',
        headerImg: 'newsData/1/images/header.jpg',
        fullDetail: [
          '"Enjoy science, Adventure thinking"',
          'โครงการ วมว. สำนักงานห้องเรียนวิศว์-วิทย์ มจธ. เปิดรับสมัครนักเรียนที่กำลังจะเรียนจบชั้นมัธยมศึกษาปีที่ 3 ในปีการศึกษา 2562 นี้ \n' +
          'เพื่อเข้ามาเป็นนักเรียนในโครงการห้องเรียนวิศว์-วิทย์ รุ่นที่ 13 ปีการศึกษา 2563 จำนวน 90 คน เพื่อเตรียมพร้อมสู่เส้นทางนักวิจัย และนักนวัตกรรมในอนาคต',
          '<b>**เปิดรับสมัครตั้งแต่วันที่ 1 - 31 สิงหาคม 2562**</b>',
          '<a href="http://scius.most.go.th/set/activity/view_detail/9/101">รายละเอียดการรับสมัคร</a>',
          '<a href="http://admission.mwit.ac.th/">สมัครออนไลน์</a>',
          'สอบถามข้อมูลเพิ่มเติมได้ที่ 02-470-8386 และ 8389 ในวันและเวลาราชการ'
        ],
        imgSet: [
        ]
      },
      {
        newsId: 2,
        header: 'ประชาสัมพันธ์ถึงผู้สมัครสอบเข้าโครงการ วมว. ปีการศึกษา 2563(1)',
        src: 'newsData/2/thumbnail.jpg',
        type: 'ประกาศ',
        data: 'notice',
        timeFormat: '03-09-2019',
        time: '3 ก.ย. 62',
        detail: 'ขณะนี้เจ้าหน้าที่แต่ละคู่ศูนย์กำลังทยอยตรวจคุณสมบัติและออกบัตรประจำตัวผู้เข้าสอบ',
        headerImg: 'newsData/2/images/header.jpg',
        fullDetail: [
          'ขณะนี้เจ้าหน้าที่แต่ละคู่ศูนย์กำลังทยอยตรวจคุณสมบัติและออกบัตรประจำตัวผู้เข้าสอบให้กับผู้สมัครทุกคน ซึ่งจะดำเนินการเสร็จสิ้นภายในวันที่ 15 กันยายน พ.ศ. 2562 หากมีปัญหาให้ติดต่อฝ่ายวิชาการ \n' +
          'โรงเรียนมหิดลวิทยานุสรณ์ ภายในวันที่ 20 กันยายน พ.ศ. 2562 ทางโทรศัพท์ หมายเลข 0-2826-7154, 0-2826-7155, 0-2826-7156, 0-2826-7157, 0-2826-7159, 0-2826-7160',
          'สำหรับคำถามที่สอบถามเกี่ยวกับการออกบัตรประจำตัวสอบ ขอแจ้งว่าการออกบัตรประจำตัวผู้เข้าสอบจะขึ้นอยู่กับคู่ศูนย์ที่เลือกสมัครสอบ โดยคู่ศูนย์จะเป็นผู้ตรวจสอบคุณสมบัติและออกบัตรประจำตัวสอบเอง ดังนี้',
          'รูปแบบที่ 1',
          'สมัครสอบโรงเรียนในโครงการ วมว. 1 โรงเรียน -->> โรงเรียนที่น้องๆ สมัครจะเป็นผู้ตรวจคุณสมบัติและออกบัตรประจำตัวสอบ',
          'สมัครสอบโรงเรียนในโครงการ วมว. 2 โรงเรียน -->> โรงเรียนในโครงการ วมว. ที่น้องๆ เลือกในลำดับที่ 1 จะเป็นผู้ตรวจคุณสมบัติและออกบัตรประจำตัวสอบ',
          'รูปแบบที่ 2',
          'สมัครสอบโรงเรียนมหิดลวิทยานุสรณ์และโรงเรียนในโครงการ วมว. 1 โรงเรียน (รวมอาจเลือกหรือไม่เลือกสมัครสถาบันโคเซ็น) -->> โรงเรียนในโครงการ วมว. ที่น้องเลือกจะเป็นผู้ตรวจคุณสมบัติและออกบัตรประจำตัวสอบ',
          'สมัครสอบโรงเรียนมหิดลวิทยานุสรณ์และโรงเรียนในโครงการ วมว. 2 โรงเรียน (รวมอาจเลือกหรือไม่เลือกสมัครสถาบันโคเซ็น) -->> โรงเรียนในโครงการ วมว. ลำดับที่ 1 ตรวจคุณสมบัติและออกบัตรประจำตัวสอบ',
          'ทั้งนี้ แต่ละคู่ศูนย์กำลังทยอยตรวจคุณสมบัติและออกบัตรประจำตัวสอบ โดยเรียงตามลำดับการสมัคร โดยสามารถล็อคอินเข้าระบบเพื่อตรวจสอบสถานะได้ตลอดเวลา',
          '<b>ขอย้ำว่า...การสมัครผ่านระบบทุกขั้นตอนผู้สมัครจะเป็นผู้ตรวจสอบและกดยืนยันการบันทึกข้อมูลลงในระบบด้วยตนเอง...ขอให้น้องๆ ระมัดระวังและตรวจสอบข้อมูลกันด้วยนะคะ</b>'
        ],
        imgSet: [
        ]
      },
      {
        newsId: 3,
        header: 'ประชาสัมพันธ์ถึงผู้สมัครสอบเข้าโครงการ วมว. ปีการศึกษา 2563(2)',
        src: 'newsData/3/thumbnail.jpg',
        type: 'ประกาศ',
        data: 'notice',
        timeFormat: '17-09-2019',
        time: '17 ก.ย. 62',
        detail: 'การเข้าตรวจสอบสถานะการสมัครในระบบรับสมัครออนไลน์',
        headerImg: 'newsData/3/images/header.jpg',
        fullDetail: [
          'การเข้าตรวจสอบสถานะการสมัครในระบบรับสมัครออนไลน์ <a href="https://admission.mwit.ac.th/Account/Login">https://admission.mwit.ac.th/Account/Login</a>',
          'เมื่อผู้สมัครเข้าสู่ระบบด้วย username และ password แล้ว สามารถเลื่อนลงมาดูสถานะได้ใน "ข้อ 5 สถานะการสมัครสอบ" โดยเบื้องต้นขอแจ้งข้อมูลสำหรับการดำเนินการดังนี้',
          '<b>กรณีที่ 1</b> หากยังไม่มีการอัพเดทแสดงว่า <b>สถานะยังอยู่ระหว่างการตรวจสอบคุณสมบัติ</b> ให้ติดต่อไปยังฝ่ายวิชาการ โรงเรียนมหิดลวิทยานุสรณ์ (เพจ ฝ่ายวิชาการ MWIT) \n' +
          'ก่อนวันที่ 20 กันยายน พ.ศ. 2562 ทางโทรศัพท์ หมายเลข 0-2826-7154, 0-2826-7155, 0-2826-7156, 0-2826-7157, 0-2826-7159, 0-2826-7160 หรืออีเมล admission@mwit.ac.th',
          '<b>กรณีที่ 2</b> หากข้อมูลอัพเดทแล้ว <b>แต่สถานะยังไม่ได้รับการอนุมัติและมีหมายเหตุแจ้งให้ส่งเอกสารหรือข้อมูลเพิ่มเติม</b> ให้ผู้สมัครรีบดำเนินการตามที่ได้รับแจ้งให้เรียบร้อยโดยด่วน\n' +
          'ก่อนวันที่ 20 กันยายน 2562 หากมีข้อสงสัยให้ติดต่อไปยังคู่ศูนย์ในโครงการ วมว. แห่งที่ 1 ที่นักเรียนสมัครสอบ รายละเอียดการติดต่อสามารถดูข้อมูลได้ตามประกาศรับสมัคร ลิ้งค์ <a href="http://scius.most.go.th/set/activity/view_detail/9/101">http://scius.most.go.th/set/activity/view_detail/9/101</a>',
          '<b>กรณีที่ 3</b> หากข้อมูลอัพเดทว่า <b>"อนุมัติ"</b> แสดงว่าผู้สมัครผ่านการตรวจสอบคุณสมบัติและมีสิทธิ์เข้าสอบ ซึ่งบริเวณแถบด้านบนจะมีปุ่ม "พิมพ์บัตรประจำตัวสอบ" ผู้เข้าสอบจะต้องปริ้นเพื่อใช้เป็นหลักฐานในการสอบทั้งสองรอบ',
          '<b>กรณีที่ 4</b> หากสถานะแจ้งว่า <b>ไม่ผ่านการอนุมัติ</b> หมายความว่า ผู้สมัครไม่ผ่านการตรวจสอบคุณสมบัติและไม่มีสิทธิ์เข้าสอบหากมีข้อสงสัยให้ติดต่อไปยังคู่ศูนย์ในโครงการ วมว. แห่งที่ 1 ที่นักเรียนสมัครสอบ \n' +
          'รายละเอียดการติดต่อสามารถดูข้อมูลได้ตามประกาศรับสมัคร ลิ้งค์ <a href="http://scius.most.go.th/set/activity/view_detail/9/101">http://scius.most.go.th/set/activity/view_detail/9/101</a>'
        ],
        imgSet: [
        ]
      },
      {
        newsId: 4,
        header: 'นักเรียนชั้นมัธยมศึกษาปีที่ 5 ได้แลกเปลี่ยนงานวิจัย ณ MIT Media Lab',
        src: 'newsData/4/thumbnail.jpg',
        type: 'ข่าว',
        data: 'news',
        timeFormat: '12-10-2019',
        time: '12 ต.ค. 62',
        detail: 'ในวันที่ 11-13 ต.ค. 2562 นายพร้อม เสือทิม นักเรียนชั้นม. 5 โรงเรียนดรุณสิกขาลัย (โครงการ วมว.)',
        headerImg: 'newsData/4/images/header.jpg',
        fullDetail: [
          'ในวันที่ 11-13 ต.ค. 2562 นายพร้อม เสือทิมนักเรียนชั้นม. 5 โรงเรียนดรุณสิกขาลัย (โครงการวมว.) ได้นำงานวิจัยเรื่อง \n' +
          'BioFab: The Next Generation of wearable devices หรือ อุปกรณ์สวมใส่และแยกส่วนได้สำหรับการสังเคราะห์และดัดแปลงสารชีวโมเลกุล \n' +
          'ไปแลกเปลี่ยนในงาน The third annual Global Summit on Community Biotechnology ณ MIT Media Lab ประเทศสหรัฐอเมริกา \n' +
          'โดยได้รับทุนสนับสนุนจำนวนหนึ่งจากงานดังกล่าวเพื่อสนับสนุนให้ไปร่วมงานที่ประเทศสหรัฐอเมริกา <a href="https://www.biosummit.org/">(รายละเอียดโครงการ)</a>\n' +
          'โดยงานวิจัยดังกล่าวมีผู้ร่วมวิจัยคือ นาย ก้องภพ ตรีรัตนวณิช นาย ไพสิฐ ลือสิริพาณิชย์ และอาจารย์ที่ปรึกษาคือ รศ.ดร. วีรศักดิ์ สุระเรืองชัย (ภาควิชา Nanoscience & Nanotechnology คณะวิทยาศาสตร์ มจธ.) \n' +
          'ดร. นิธิพนธ์ พุทธรักษา (สำนักงานคณบดี คณะวิทยาศาสตร์ มจธ.) อ. จินตนา วงศ์ต๊ะ และ อ. กฤษดา ดวงจิตต์เจริญ (สำนักงานห้องเรียนวิศว์-วิทย์ มจธ.)',
          'พร้อมได้เล่าว่า ผมได้เจอกลุ่มคนที่มีแนวคิดเหมือนๆ กัน ได้เจอคนที่ชอบอะไรแบบเดียวกัน เป็นกลุ่มคนที่มีความทะเยอทะยานและมีความแหวกแนวสูงมาก เป็นคนที่กล้าที่จะล้มเหลวและไอเดียก้าวไกล \n' +
          'เขาจะไม่ถามว่าโปรเจคนี้มีประโยชน์หรือ ผลกับปัจจุบันยังไง แต่จะถามว่าในอนาคตโปรเจคนี้จะทำให้มุมมองของคนทั้งโลกเปลี่ยนไปอย่างไร \n',
          'นอกจากนี้ยังได้มีโอกาสเข้าร่วม Workshop และร่วมฟังงานวิจัยต่างๆ ที่หลากหลาย เช่น งาน <a href="https://giybiobuddies.weebly.com">GIY Bio Buddy</a>  ที่เล่าว่า จริงๆ แล้ว Fashion ที่เราใส่ทุกวันนั้นเป็นอะไรที่ทำลายโลกมากๆ เพราะ Fashion นั้นเปลี่ยนตลอดเวลาและเสื้อผ้าทุกตัวต้องผลิตขึ้นมาใหม่เพื่อสนองความต้องการของเรา \n' +
          'แต่เสื้อผ้านั้นทำจากวัสดุที่ย่อยยาก พอเป็นขยะก็กลายเป็นปัญหา วิธีแก้ปัญหานั้นกลุ่มคนใน biosummit ก็คิดว่าควรทำbiomaterial ให้มาเป็นชุด แต่ถึงกระนั้นคนก็ไม่ชอบอีก \n' +
          'ก็มีโปรเจคบางอันอย่าง GIY Biobuddies พยายามทำให้คนนั้นคุ้นชินกับเสื้อผ้าแนวใหม่นี้มากขึ้นว่าจริงๆ แล้วก็ไม่ได้ต่างอะไรกับเสื้อผ้าปกติมาก\n' +
          'รือโปรเจคที่เอา 3d printer มาปริ้น E. coli ที่มีสีบน แผ่น media เพราะเขาอยากรู้ว่ามนุษย์จะสามารถใช้ชีววิทยาเป็นศิลปะเพื่อที่จะแสดงความเป็นตัวเองออกมาได้หรือไม่ \n' +
          'หรือมีบางโปรเจคที่ใช้หุ่นยนต์เลี้ยงเชื้อราในสภาวะที่แนบเนียนและกลมกลืนกับธรรมชาติมากที่สุด'
        ],
        imgSet: [
          '/GiftEd/static/newsData/4/images/0.jpg',
          '/GiftEd/static/newsData/4/images/1.jpg',
          '/GiftEd/static/newsData/4/images/2.jpg',
          '/GiftEd/static/newsData/4/images/3.jpg',
          '/GiftEd/static/newsData/4/images/4.jpg',
          '/GiftEd/static/newsData/4/images/5.jpg'
        ]
      },
      {
        newsId: 5,
        header: 'ประกาศรับสมัครบุคลากรทั้ง 5 สาขา',
        src: 'newsData/5/thumbnail.jpg',
        type: 'ประกาศ',
        data: 'notice',
        timeFormat: '08-11-2019',
        time: '8 พ.ย. 62',
        detail: 'ถ้าคุณรักในความเป็นครู ห้องเรียนวิศว์-วิทย์ ขอชวนคุณมาสร้างคน สร้างนวัตกรรมทางการศึกษา เพื่อพัฒนาชาติไปด้วยกัน',
        headerImg: 'newsData/5/images/header.jpg',
        fullDetail: [
          '"ถ้าคุณรักในความเป็นครู ห้องเรียนวิศว์-วิทย์ ขอชวนคุณมาสร้างคน สร้างนวัตกรรมทางการศึกษา เพื่อพัฒนาชาติไปด้วยกัน"',
          'หากคุณสนใจ.....ศึกษารายละเอียดและส่งข้อมูลมาที่',
          '<b>email :</b> n_taohu@hotmail.com',
          '<b>สอบถามข้อมูลเพิ่มเติม :</b> 02-4708386 หรือ 02-4708389'
        ],
        imgSet: [
          '/GiftEd/static/newsData/5/images/0.jpg',
          '/GiftEd/static/newsData/5/images/1.jpg',
          '/GiftEd/static/newsData/5/images/2.jpg',
          '/GiftEd/static/newsData/5/images/3.jpg',
          '/GiftEd/static/newsData/5/images/4.jpg',
          '/GiftEd/static/newsData/5/images/5.jpg',
          '/GiftEd/static/newsData/5/images/6.jpg',
          '/GiftEd/static/newsData/5/images/7.jpg',
          '/GiftEd/static/newsData/5/images/8.jpg',
          '/GiftEd/static/newsData/5/images/9.jpg',
          '/GiftEd/static/newsData/5/images/10.jpg',
          '/GiftEd/static/newsData/5/images/11.jpg'
        ]
      },
      {
        newsId: 6,
        header: 'ประกาศสถานที่สอบคัดเลือกนักเรียนเพื่อเข้าเป็นนักเรียน ชั้นมัธยมศึกษาปีที่ 4',
        src: 'newsData/6/thumbnail.jpg',
        type: 'ประกาศ',
        data: 'notice',
        timeFormat: '13-11-2019',
        time: '13 พ.ย. 62',
        detail: 'ข้อมูลห้องสอบและอาคารสอบของนักเรียนที่เลือกศูนย์สอบรอบแรก ที่มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรี',
        headerImg: 'newsData/6/images/header.jpg',
        fullDetail: [
          'ข้อมูลห้องสอบและอาคารสอบของนักเรียนที่เลือกศูนย์สอบรอบแรก ที่มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรี สามารถดูสถานที่ห้องสอบได้จากแผนที่ด้านล่าง'
        ],
        imgSet: [
          '/GiftEd/static/newsData/6/images/0.jpg',
          '/GiftEd/static/newsData/6/images/1.jpg',
          '/GiftEd/static/newsData/6/images/2.jpg'
        ]
      },
      {
        newsId: 7,
        header: 'ประกาศรายชื่อนักเรียนสอบผ่านการคัดเลือกรอบแรก สถาบันโคเซ็น มจธ. และโรงเรียนดรุณสิกขาลัย (โครงการ วมว.)',
        src: 'newsData/7/thumbnail.jpg',
        type: 'ประกาศ',
        data: 'notice',
        timeFormat: '23-12-2019',
        time: '23 ธ.ค. 62',
        detail: '',
        headerImg: 'newsData/7/images/header.jpg',
        fullDetail: [
          'ประกาศรายชื่อผู้ผ่านการสอบคัดเลือกรอบที่หนึ่ง (เรียงตามเลขประจำตัวสอบ) และมีสิทธิ์เข้าสอบรอบสองเพื่อเข้าเป็นนักศึกษา <b style="color: #FFA500;">สถาบันโคเซ็น มจธ.</b> ชั้นปีที่ 1 ได้ตามเอกสารด้านล่าง',
          '<p style="text-align: center; font-size: 24px;padding: 20px 0;"><a href="/GiftEd/static/newsData/7/documents/KOSEN/list.pdf" target="_blank" class="link">ประกาศรายชื่อนักเรียนที่มีสิทธิ์สอบรอบสอง (สถาบันโคเซ็น มจธ.)</a></p>',
          '<p style="text-align: center; font-size: 28px">เอกสารเพิ่มเติม</p>',
          '<a href="/GiftEd/static/newsData/7/documents/KOSEN/notice.pdf" target="_blank">- ประกาศสถาบันโคเซ็น มจธ.</a>',
          '<a href="/GiftEd/static/newsData/7/documents/KOSEN/attachment.pdf" target="_blank">- กำหนดการและรายละเอียดการสอบคัดเลือกรอบสองสถาบันโคเซ็น มจธ</a>',
          '<a href="/GiftEd/static/newsData/7/documents/KOSEN/postponement.pdf" target="_blank">- ประกาศแจ้งเลื่อนสอบรอบ 2</a>',
          '<a href="/GiftEd/static/newsData/7/documents/KOSEN/request_form.pdf" target="_blank">- แบบฟอร์มขอดูคะแนนสอบ (โคเซ็น)</a>',
          '<div style="margin-bottom: 60px;"></div>',
          'ประกาศรายชื่อผู้ผ่านการสอบคัดเลือกรอบที่หนึ่ง (เรียงตามเลขประจำตัวสอบ) และมีสิทธิ์เข้าสอบรอบสองเพื่อเข้าเป็นนักเรียน <b style="color: #FFA500;">โรงเรียนดรุณสิกขาลัย (โครงการ วมว.)</b> ได้ตามเอกสารด้านล่าง',
          '<p style="text-align: center; font-size: 24px;padding: 20px 0;"><a href="/GiftEd/static/newsData/7/documents/ESC/list.pdf" target="_blank" class="link">ประกาศรายชื่อนักเรียนที่มีสิทธิ์สอบรอบสอง (โครงการ วมว.)</a></p>',
          '<p style="text-align: center; font-size: 28px">เอกสารเพิ่มเติม</p>',
          '<a href="/GiftEd/static/newsData/7/documents/ESC/notice.pdf" target="_blank">- ประกาศโครงการ วมว.</a>',
          '<a href="/GiftEd/static/newsData/7/documents/ESC/attachment.pdf" target="_blank">- กำหนดการและรายละเอียดการสอบคัดเลือกรอบสอง โครงการ วมว.</a>',
          '<a href="/GiftEd/static/newsData/7/documents/ESC/attachment2.pdf" target="_blank">- การสนับสนุนค่าใช้จ่ายในการสอบคัดเลือกรอบสอง โครงการ วมว.</a>',
          '<a href="/GiftEd/static/newsData/7/documents/ESC/request_form.pdf" target="_blank">- แบบฟอร์มขอดูคะแนนสอบ (โครงการ วมว.)</a>',
          '<div style="margin-bottom: 60px;"></div>',
          'นักเรียนที่ผ่านการคัดเลือกในรอบที่หนึ่ง จะต้องลงทะเบียนสอบในรอบที่สองได้จากลิงก์ด้านล่าง',
          '<p style="text-align: center; font-size: 28px;padding: 20px 0;"><a href="https://reg-gifted.kmutt.ac.th" target="_blank" class="link">ลงทะเบียนเพื่อยืนยันสิทธิ์เข้าสอบรอบสอง<br>สถาบันโคเซ็น มจธ.และโรงเรียนดรุณสิกขาลัย (โครงการ วมว.)</a></p>',
          '<span style="color: red;">หมายเหตุ : ระบบจะเปิดยืนยันสิทธิ์การเข้าสอบคัดเลือกรอบ 2 : วันที่ 24 ธันวาคม 2562- 10 มกราคม 2563</span>',
          '<span style="color: red;">นักเรียนจะต้องชำระค่าลงทะเบียนเพื่อยืนยันสิทธิ์การเข้าสอบรอบ 2 ผ่านทางธนาคารภายในวันที่ 10 มกราคม 2563</span>',
          '<span style="color: red;">หากพ้นกำหนดถือว่านักเรียนสละสิทธิ์การเข้าสอบ (ไม่รับชำระค่าลงทะเบียนสอบในวันสอบรอบ 2)</span>'
        ],
        imgSet: [
        ]
      },
      {
        newsId: 8,
        header: 'ประกาศเลขที่นั่งสอบและรายละเอียดการเข้าสอบคัดเลือกรอบสอง โครงการ วมว. สำนักงานห้องเรียนวิศว์-วิทย์ (25-26 มกราคม 2563)',
        src: 'newsData/8/thumbnail.jpg',
        type: 'ประกาศ',
        data: 'notice',
        timeFormat: '20-01-2020',
        time: '20 ม.ค. 63',
        detail: '',
        headerImg: 'newsData/8/images/header.jpg',
        fullDetail: [
          'นักเรียนและผู้ปกครองสามารถตรวจสอบห้องสอบและเลขที่นั่งสอบและกำหนดการสอบรอบสองได้ทางลิงก์ที่อยู่ด้านล่าง',
          '<p class="my-4" style="text-align: center; font-size: 24px;"><a href="/GiftEd/static/newsData/8/documents/กำหนดการสอบรอบสอง.pdf" target="_blank" class="link">กำหนดการสอบคัดเลือกรอบที่สอง</a></p>',
          '<p class="mb-4" style="text-align: center; font-size: 24px;"><a href="https://reg-gifted.kmutt.ac.th/Search_StduentRoom" target="_blank" class="link">ตรวจสอบห้องสอบและเลขที่นั่งสอบ</a></p>',
          'หรือสามารถตรวจสอบห้องสอบและเลขที่นั่งสอบสอบได้จากลิงก์ที่อยู่ด้านล่าง',
          '<div class="row my-5"> \n' +
          '<div class="col-md-4 text-center"> \n' +
          '<a href="/GiftEd/static/newsData/8/documents/SCL216.pdf" target="_blank" style="font-size: 22px;">SCL216</a> \n' +
          '</div> \n' +
          '<div class="col-md-4 text-center"> \n' +
          '<a href="/GiftEd/static/newsData/8/documents/SCL124.pdf" target="_blank" style="font-size: 22px;">SCL124</a> \n' +
          '</div> \n' +
          '<div class="col-md-4 text-center"> \n' +
          '<a href="/GiftEd/static/newsData/8/documents/CH103.pdf" target="_blank" style="font-size: 22px;">CH103</a> \n' +
          '</div> \n' +
          '</div>',
          'สถานที่รายงานตัวนักเรียนเพื่อเข้าสอบคัดเลือกรอบสอง ในวันที่ 25 มกราคม 2563 เวลา 08.00 - 08.30 น. สามารถดูได้ในแผนที่ <span style="color: red;">(อาคารหมายเลข 31 อาคารปฏิบัติการพื้นฐานทางวิทยาศาสตร์)</span>',
          '<p class="text-center" style="font-size: 24px;"><a href="/GiftEd/static/newsData/8/documents/map.pdf">เปิดแผนที่</a></p>'
        ],
        imgSet: [
        ]
      },
      {
        newsId: 9,
        header: 'ประกาศเลขที่นั่งสอบและรายละเอียดการเข้าสอบคัดเลือกรอบสอง โครงการ KOSEN',
        src: 'newsData/9/thumbnail.jpg',
        type: 'ประกาศ',
        data: 'notice',
        timeFormat: '11-02-2020',
        time: '11 ก.พ. 63',
        detail: '',
        headerImg: 'newsData/9/images/header.jpg',
        fullDetail: [
          'นักเรียนและผู้ปกครองสามารถตรวจสอบห้องสอบและเลขที่นั่งสอบและกำหนดการสอบคัดเลือกรอบที่สองได้ทางลิงก์ที่อยู่ด้านล่าง',
          '<p class="text-center"><a href="/GiftEd/static/newsData/9/documents/กำหนดการสอบคัดเลือกรอบสอง.pdf" target="_blank" style="font-size: 24px;">กำหนดการสอบคัดเลือกรอบสอง</a></p>',
          'ทางสถาบันฯ ได้จัดกิจกรรม “ถาม – ตอบ ข้อซักถาม โครงการ KOSEN KMUTT” ให้กับผู้ปกครองในช่วงเวลา 09.30 – 12.00 น. ณ ห้อง SC2109 คณะวิทยาศาสตร์',
          '<p class="text-center"><a href="https://reg-gifted.kmutt.ac.th/Search_StudentRoomKosen" target="_blank" style="font-size: 24px;">ตรวจสอบห้องสอบและเลขที่นั่งสอบ</a></p>',
          'หรือสามารถตรวจสอบและเลขที่นั่งสอบได้จากลิงค์ที่อยู่ด้านล่าง',
          '<p class="text-center"><a href="/GiftEd/static/newsData/9/documents/SCL216.pdf" target="_blank" style="font-size: 22px;text-decoration: underline;">SCL216</a></p>',
          '<p class="text-center"><a href="/GiftEd/static/newsData/9/documents/SCL124.pdf" target="_blank" style="font-size: 22px;text-decoration: underline;">SCL124</a></p>',
          'หรือสามารถตรวจสอบและเลขที่นั่งสอบได้จากลิงค์ที่อยู่ด้านล่าง',
          'สถานที่รายงานตัวนักเรียนเพื่อเข้าสอบคัดเลือกรอบสอง ในวันที่ 15 กุมภาพันธ์ 2563 เวลา 08.00 - 08.30 น. สามารถดูได้ในแผนที่<span style="color:red;">(อาคารหมายเลข 31 อาคารปฏิบัติการพื้นฐานทางวิทยาศาสตร์)</span>',
          '<p class="text-center"><a href="/GiftEd/static/newsData/9/documents/map.pdf" target="_blank" style="font-size: 24px;text-decoration: underline;">เปิดแผนที่</a></p>',
          'เอกสารแนบท้าย',
          '<a href="/GiftEd/static/newsData/9/documents/เอกสารแนบท้าย2.pdf" target="_blank" style="font-size: 20px;text-decoration: underline;">ประกาศสถาบันโคเซ็น มจธ. เรื่องแจ้งเปลี่ยนแปลงรายชื่อผู้มีสิทธิเข้าสอบคัดเลือกรอบ2</a></p>',
          '<a href="/GiftEd/static/newsData/9/documents/เอกสารแนบท้าย1.pdf" target="_blank" style="font-size: 20px;text-decoration: underline;">รายชื่อผู้ผ่านการสอบคัดเลือกรอบแรก</a></p>'
        ],
        imgSet: [
        ]
      },
      {
        newsId: 10,
        header: 'ประกาศเลขที่นั่งสอบและรายละเอียดการเข้าสอบคัดเลือกรอบสอง “โครงการพัฒนากาลังคนด้าน วิศวกรรมศาสตร์ เทคโนโลยีและนวัตกรรม สนับสนุนการลงทุนและเพิ่มขีดความสามารถภาคอุตสาหกรรมใน ประเทศและภูมิภาค”',
        src: 'newsData/9/thumbnail.jpg',
        type: 'ประกาศ',
        data: 'notice',
        timeFormat: '11-02-2020',
        time: '11 ก.พ. 63',
        detail: '',
        headerImg: 'newsData/9/images/header.jpg',
        fullDetail: [
          'ประกาศสถาบันโคเซ็น มจธ. เรื่องแจ้งเปลี่ยนแปลงรายชื่อผู้มีสิทธิเข้าสอบคัดเลือกรอบ2 นักเรียนและผู้ปกครองสามารถตรวจสอบประกาศได้จากลิงค์ที่อยู่ด้านล่าง',
          '<p class="text-center"><a href="/GiftEd/static/newsData/10/documents/ประกาศสถาบัน.pdf" target="_blank" style="font-size: 22px;">ประกาศสถาบันโคเซ็น มจธ. เรื่องแจ้งเปลี่ยนแปลงรายชื่อผู้มีสิทธิเข้าสอบคัดเลือกรอบ2</a></p>',
          'ประกาศรายชื่อผู้ผ่านการคัดเลือกรอบแรก นักเรียนและผู้ปกครองสามารถตรวจสอบประกาศได้จากลิงค์ที่อยู่ด้านล่าง',
          '<p class="text-center"><a href="/GiftEd/static/newsData/10/documents/รายชื่อผู้ผ่านการคัดเลือกรอบแรก.pdf" target="_blank" style="font-size: 22px;">รายชื่อผู้ผ่านการสอบคัดเลือกรอบแรก</a></p>'
        ],
        imgSet: [
        ]
      },
      {
        newsId: 11,
        header: '(Update) ประกาศกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม เรื่อง ผลการสอบคัดเลือกนักเรียนเพื่อเข้าเป็นนักเรียนชั้นมัธยมศึกษาปีที่ 4',
        src: 'newsData/11/thumbnail.jpg',
        type: 'ประกาศ',
        data: 'notice',
        timeFormat: '09-03-2020',
        time: '9 มี.ค. 63',
        detail: '',
        headerImg: 'newsData/11/images/header.jpg',
        fullDetail: [
          'ประกาศกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม เรื่อง ผลการสอบคัดเลือกนักเรียนเพื่อเข้าเป็นนักเรียนชั้นมัธยมศึกษาปีที่ 4 ใน “โครงการสนับสนุนการจัดตั้งห้องเรียนวิทยาศาสตร์ในโรงเรียน โดยการกำกับดูแลของมหาวิทยาลัย ระยะที่ 2” ของกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม ประจำปีการศึกษา 2563',
          '<p class="text-center"><a href="/GiftEd/static/newsData/11/documents/ประกาศกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม.pdf" target="_blank" style="font-size: 18px;">ประกาศกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม</a></p>',
          '<p class="text-center"><a href="/GiftEd/static/newsData/11/documents/รายชื่อนักเรียนผู้ผ่านการคัดเลือกเพื่อเข้าเป็นนักเรียนชั้นมัธยมศึกษาปีที่ 4.pdf" target="_blank" style="font-size: 18px;">รายชื่อนักเรียนผู้ผ่านการคัดเลือกเพื่อเข้าเป็นนักเรียนชั้นมัธยมศึกษาปีที่ 4 (ตัวจริงและตัวสำรอง)</a></p>',
          '<p class="text-center"><a href="/GiftEd/static/newsData/11/documents/กำหนดการรายงานตัวและมอบตัว.pdf" target="_blank" style="font-size: 18px;">กำหนดการรายงานตัวและมอบตัว</a></p>',
          '<p class="text-center"><a href="/GiftEd/static/newsData/11/documents/สถานที่ยื่นขอดูคะแนนสอบ.pdf" target="_blank" style="font-size: 18px;">สถานที่ขอยื่นดูคะแนนสอบ</a></p>',
          '<p class="text-center"><a href="/GiftEd/static/newsData/11/documents/แบบฟอร์มขอยื่นดูคะแนนสอบ.pdf" target="_blank" style="font-size: 18px;">แบบฟอร์มขอยื่นดูคะแนนสอบ</a></p>'
        ],
        imgSet: [
        ]
      },
      {
        newsId: 12,
        header: 'ลงทะเบียนยืนยันสิทธิ์/รายงานตัว หรือสละสิทธิ์ การเข้าเป็นนักเรียนโรงเรียนดรุณสิกขาลัย(โครงการ วมว.) ประจำปีการศึกษา 2563',
        src: 'newsData/12/thumbnail.jpg',
        type: 'ประกาศ',
        data: 'notice',
        timeFormat: '10-03-2020',
        time: '10 มี.ค. 63',
        detail: '',
        headerImg: 'newsData/12/images/header.jpg',
        fullDetail: [
          '<div>ลงทะเบียนยืนยันสิทธิ์/รายงานตัว หรือสละสิทธิ์ การเข้าเป็นนักเรียนโรงเรียนดรุณสิกขาลัย(โครงการ วมว.) ประจำปีการศึกษา 2563</div>',
          '<div class="text-center"><a href="https://reg-gifted.kmutt.ac.th/UserLogin" target="_blank" style="font-size: 18px;">เข้าสู่ระบบลงทะเบียน</a></div>',
          '<div>ตรวจสอบสถานะการยืนยันสิทธิ์การเข้าเป็นนักเรียน โรงเรียนดรุณสิกขาลัย (โครงการ วมว.) ประจำปีการศึกษา 2563</div>',
          '<div class="text-center"><a href="https://reg-gifted.kmutt.ac.th/Check_Student_Status" target="_blank" style="font-size: 18px;">ตรวจสถานะลงทะเบียน</a></div>'
        ],
        imgSet: [
        ]
      },
      {
        newsId: 13,
        header: 'ประกาศเรื่อง ผลการสอบคัดเลือกนักเรียนเพื่อเข้าเป็นนักศึกษาสถาบันไทยโคเซ็น ชั้นปีที่ 1',
        src: 'newsData/13/thumbnail.jpg',
        type: 'ประกาศ',
        data: 'notice',
        timeFormat: '10-03-2020',
        time: '10 มี.ค. 63',
        detail: '',
        headerImg: 'newsData/13/images/header.jpg',
        fullDetail: [
          '<div>ประกาศเรื่อง ผลการสอบคัดเลือกนักเรียนเพื่อเข้าเป็นนักศึกษาสถาบันไทยโคเซ็น ชั้นปีที่ 1 ใน “โครงการพัฒนากำลังคนด้านวิศวกรรมศาสตร์ เทคโนโลยีและนวัตกรรมสนับสนุนการลงทุนและเพิ่มขีดความสามารถภาคอุตสาหกรรมในประเทศและภูมิภาค” ประจำปีการศึกษา 2563</div>',
          '<div class="text-left"><a href="/GiftEd/static/newsData/13/documents/ประกาศ.pdf" target="_blank" style="font-size: 18px;">ประกาศ</a></div>',
          '<div class="text-left"><a href="/GiftEd/static/newsData/13/documents/รายชื่อนักเรียนผู้ผ่านการคัดเลือกเพื่อเข้าเป็นนักศึกษา KOSEN KMUTT ชั้นปีที่ 1.pdf" target="_blank" style="font-size: 18px;">รายชื่อนักเรียนผู้ผ่านการคัดเลือกเพื่อเข้าเป็นนักศึกษา KOSEN KMUTT ชั้นปีที่ 1</a></div>',
          '<div class="text-left"><a href="/GiftEd/static/newsData/13/documents/กำหนดการรายงานตัวและมอบตัว.pdf" target="_blank" style="font-size: 18px;">กำหนดการรายงานตัวและมอบตัว</a></div>',
          '<div class="text-left" style="font-size: 18px;"><a href="/GiftEd/static/newsData/13/documents/สถานที่ขอยื่นดูคะแนนสอบ.pdf" target="_blank">สถานที่ขอยื่นดูคะแนนสอบ</a> / <a href="/GiftEd/static/newsData/13/documents/แบบฟอร์มขอยื่นดูคะแนนสอบ.pdf" target="_blank">แบบฟอร์มขอยื่นดูคะแนนสอบ</a></div>'
        ],
        imgSet: [
        ]
      },
      {
        newsId: 14,
        header: 'ระบบลงทะเบียนยืนยันสิทธิ์/รายงานตัว หรือสละสิทธิ์ การเข้าเป็นนักศึกษา ชั้นปีที่ 1 KOSEN KMUTT ประจำปีการศึกษา 2563',
        src: 'newsData/14/thumbnail.jpg',
        type: 'ประกาศ',
        data: 'notice',
        timeFormat: '16-03-2020',
        time: '16 มี.ค. 63',
        detail: '',
        headerImg: 'newsData/14/images/header.jpg',
        fullDetail: [
          'ระบบลงทะเบียนยืนยันสิทธิ์/รายงานตัว หรือสละสิทธิ์ การเข้าเป็นนักศึกษา ชั้นปีที่ 1 KOSEN KMUTT ประจำปีการศึกษา 2563 นักเรียนและผู้ปกครองสามารถเข้าผ่านทางลิงก์ที่อยู่ด้านล่าง',
          '<div class="text-center"><a href="https://reg-gifted.kmutt.ac.th/UserLogin_Kosen" target="_blank" style="font-size: 20px;">ลงทะเบียน</a></div>',
          'นักเรียนและผู้ปกครองสามารถตรวจสอบสถานะการยืนยันสิทธิ์การเข้าเป็นการเข้าเป็นนักศึกษา ชั้นปีที่ 1 KOSEN KMUTT ประจำปีการศึกษา 2563 ได้ผ่านทางลิงก์ด้านล่าง',
          '<div class="text-center"><a href="https://reg-gifted.kmutt.ac.th/Check_Student_Status_Kosen" target="_blank" style="font-size: 20px;">ตรวจสอบสถานะ</a></div>'
        ],
        imgSet: [
        ]
      },
      {
        newsId: 15,
        header: '(Update!!) ประกาศรายชื่อนักเรียนสำรองเพื่อรายงานตัวเข้าเป็นนักเรียนโครงการ วมว ประจำปีการศึกษา​ 2563',
        src: 'newsData/15/thumbnail.jpg',
        type: 'ประกาศ',
        data: 'notice',
        timeFormat: '09-04-2020',
        time: '9 เม.ย. 63',
        detail: '',
        headerImg: 'newsData/15/images/header.jpg',
        fullDetail: [
          'นักเรียนและผู้ปกครองสามารถเข้าไปในระบบลงทะเบียนยืนยันสิทธิ์/รายงานตัว หรือสละสิทธิ์ การเข้าเป็นนักเรียน(สำรอง)โรงเรียนดรุณสิกขาลัย(โครงการ วมว.) ประจำปีการศึกษา 2563',
          '<div class="text-center"><a href="https://reg-gifted.kmutt.ac.th/UserLogin" target="_blank" style="font-size: 20px;">ลงทะเบียนยืนยัน</a></div>'
        ],
        imgSet: [
        ]
      },
      {
        newsId: 16,
        header: '(Update!!) ประกาศรายชื่อนักเรียนสำรองเพื่อรายงานตัวเข้าเป็นนักศึกษา KOSEN KMUTT ชั้นปีที่ 1 ประจำปีการศึกษา 2563',
        src: 'newsData/15/thumbnail.jpg',
        type: 'ประกาศ',
        data: 'notice',
        timeFormat: '09-04-2020',
        time: '9 เม.ย. 63',
        detail: '',
        headerImg: 'newsData/15/images/header.jpg',
        fullDetail: [
          'ระบบลงทะเบียนยืนยันสิทธิ์/รายงานตัว หรือสละสิทธิ์ เข้าเป็นนักศึกษา KOSEN KMUTT (สำรอง) ชั้นปีที่ 1 ประจำปีการศึกษา 2563',
          '<div class="text-center"><a href="https://reg-gifted.kmutt.ac.th/UserLogin_kosen" target="_blank" style="font-size: 20px;">ลงทะเบียนยืนยัน</a></div>'
        ],
        imgSet: [
        ]
      },
      {
        newsId: 17,
        header: 'KOSEN KMUTT ประกาศรับสมัครบุคคลในตำแหน่งอาจารย์มัธยม สาขาภาษาญี่ปุ่น',
        src: 'newsData/17/thumbnail.jpg',
        type: 'ประกาศ',
        data: 'notice',
        timeFormat: '13-04-2020',
        time: '13 เม.ย. 63',
        detail: '',
        headerImg: 'newsData/17/images/header.jpg',
        fullDetail: [
          'โครงการ KOSEN KMUTT มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรี มีความประสงค์รับสมัครบุคคลในตำแหน่งอาจารย์มัธยม สาขาภาษาญี่ปุ่น โดยปฏิบัติหน้าที่สอนรายวิชาภาษาญี่ปุ่น ณ มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรี บางขุนเทียน โดยมีรายละเอียด <a href="/GiftEd/static/newsData/17/documents/recruitment.pdf" target="_blank">ตามไฟล์ที่แนบมานี้</a> (ตั้งแต่วันนี้ - 17 เมษายน 2563) \n',
          'タイ国　キングモンクット工科大学トンブリ校 (KMUTT) 高等専門学校 (KOSEN KMUTT) で、日本語教師を募集しております。詳しくは<a href="/GiftEd/static/newsData/17/documents/recruitment.pdf" target="_blank">添付ファイル</a>に書いてあります。ご興味があればどうぞ。 ご応募お待ちしております (本日〜2020年4月17日)'
        ],
        imgSet: [
        ]
      },
      {
        newsId: 18,
        header: 'ประกาศสถาบันโคเซ็น มจธ เรื่องการสอบคัดเลือกรอบที่ 2 ประจำปีการศึกษา 2564',
        src: 'newsData/18/thumbnail.jpg',
        type: 'ประกาศ',
        data: 'notice',
        timeFormat: '17-02-2021',
        time: '17 ก.พ 6',
        detail: '',
        headerImg: 'newsData/18/images/header.jpg',
        fullDetail: [
          '<h3>วันอาทิตย์ที่ 21 กุมภาพันธ์ 2564 ณ มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรี บางมด\n',
          '<h3 style="color:blue;">-ประกาศสถาบันโคเซ็นฯ\n',
          '<h3 style="color:blue;">-ตารางสอบ\n',
          '<h3 style="color:blue;">-เลขที่นั่งสอบ ห้องสอบ และสถานที่รายงานตัว\n',
          'รายละเอียด <a href="https://drive.google.com/drive/folders/1UzGyDEnAVg_VNlE5hPuUmiklIhCYmYpL?usp=sharing" target="_blank">ตามไฟล์ที่แนบมานี้</a>\n',
          '<b>ทางสถาบันขอให้นักเรียนเตรียมตัวและดำเนินการ ดังนี้</b>\n',
          'ก่อนวันสอบ กรอกแบบฟอร์มการคัดกรองการเดินทางในพื้นที่เสี่ยง (ไม่ต้องปริ้น) ภายในวันศุกร์ที่ 19 กุมภาพันธ์ 2564 <a href="https://drive.google.com/drive/folders/1UzGyDEnAVg_VNlE5hPuUmiklIhCYmYpL?usp=sharing" target="_blank">คลิกเพื่อกรอกแบบฟอร์ม</a>\n',
          '<h3 style="color:red;">วันเข้าสอบ ตรวจสอบเลขที่นั่งสอบและสถานที่จุดลงทะเบียน เพื่อป้องกันการเดินทางไปผิด\n',
          '<h3 style="color:red;">สวมหน้ากากอนามัย หรือหน้ากากผ้า ตลอดเวลา เตรียม บัตรประจำตัวผู้สอบ หรือ บัตรประชาชน หรือ บัตรนักเรียนที่มีรูปภาพ และชื่อ ชัดเจน\n',
          '<h3 style="color:red;">อุปกรณ์ที่ให้นำติดตัวเข้าห้องสอบ คือ ปากกาลูกลื่นสีน้ำเงินหรือสีดำ ดินสอ ลิควิค หรืออุปกรณ์ลบคำผิด  ยางลบดินสอ และไม้บรรทัดที่ไม่มีตารางธาตุและสูตรคำนวณทุกชนิด ทั้งนี้หากนำนาฬิกาเข้าห้องสอบต้องเป็นนาฬิกาข้อมือแบบเข็มที่ใช้ดูเวลาเท่านั้น\n',
          '<h3 style="color:red;">โทรศัพท์มือถือให้ปิดเครื่อง และใส่ไว้ในกระเป๋าวางไว้หน้าห้องสอบ หรือ หากไม่นำเข้าให้ฝากผู้ปกครอง</h2>\n'

        ],
        imgSet: [
        ]
      },
      {
        newsId: 19,
        header: 'ประกาศสถาบันโคเซ็น มจธ เรื่องการคัดเลือกนักเรียนโครงการโคเซ็น มจธ. เพื่อได้รับสิทธิ์ในการคัดเลือกและรับทุนการศึกษาต่อชั้นปีที่ 3-5 ณ สถาบันโคเซ็น ประเทศญี่ปุ่น ประจำปีการศึกษา 2565',
        src: 'newsData/19/thumbnail.jpg',
        type: 'ประกาศ',
        data: 'notice',
        timeFormat: '15-06-2021',
        time: '15 มิ.ย. 64',
        detail: '',
        headerImg: 'newsData/19/images.jpg',
        fullDetail: [
          '<h4>ด้วยโครงการพัฒนากำลังคนด้านวิศวกรรมศาสตร์ เทคโนโลยี และนวัตกรรมสนับสนุนการลงทุนและเพิ่มขีดความสามารถภาคอุตสาหกรรมในประเทศและภูมิภาค ได้จัดสรรทุนสนับสนุนนักเรียนในการเข้าศึกษา ต่อ ณ สถาบันเทคโนโลยีแห่งชาติ (KOSEN NIT) ประเทศญี่ปุ่น ชั้นปีที่ 3-5 ประจำปีการศึกษา 2565 \n',
          '<h4>แก่นักเรียนในสถาบันโคเซ็น มจธ. จำนวนไม่เกิน 4 ทุน ดังนั้นสำนักงานห้องเรียนวิศว์-วิทย์ในฐานะผู้รับผิดชอบการดำเนินการสถาบันโคเซ็น มจธ.\n',
          '<h4>จึงขอประกาศการรับสมัคร คุณสมบัติและกระบวนการในการพิจารณาผู้สมควรได้รับสิทธิ์ในการคัดเลือกและรับทุนการศึกษาประจำปีการศึกษา 2565\n',
          '<h1>รายละเอียด <a href="https://drive.google.com/file/d/1WLpu7T2e8PLNZr-HDltm6RmKTw3EIZSH/view?usp=sharing" target="_blank">ตามไฟล์ที่แนบมานี้</a>\n'
        ],
        imgSet: [
        ]
      },
      {
        newsId: 20,
        header: '2022年度新入生募集 ประกาศรับสมัครนักเรียนเพื่อเข้าศึกษาประจำปีการศึกษา 2565',
        src: 'newsData/20/thumbnail.jpg',
        type: 'ประกาศ',
        data: 'notice',
        timeFormat: '29-07-2021',
        time: '29 ก.ค. 64',
        detail: '',
        headerImg: 'newsData/20/images.jpg',
        fullDetail: [
          '<h4>โครงการ วมว. (โรงเรียนดรุณสิกขาลัย) เปิดรับสมัครนักเรียนระดับชั้นมัธยมศึกษาปีที่ ม.3 หรือเทียบเท่า เพื่อคัดเลือกเข้าเป็นนักเรียนในโครงการจัด\n',
          '<h4>ตั้งห้องเรียนวิทยาศาสตร์ในโรงเรียน โดยการกำกับดูแลของมหาวิทยาลัย (โครงการ วมว. ระยะที่ 3) ประจำปีการศึกษา 2565 เปิดรับสมัครระหว่างวันที่ 1-31 สิงหาคม 2564\n',
          '<h1>รายละเอียดการสมัครและประกาศรับสมัคร <a href="http://scius.most.go.th/set/activity/view_detail/9/120" target="_blank">http://scius.most.go.th/set/activity/view_detail/9/120</a>\n',
          '<h4>สมัครออนไลน์ผ่านทางเว็ปไซต์\n',
          '<h1><a href=" https://www.mwit.ac.th/" target="_blank"> https://www.mwit.ac.th/</a>\n',
          '<h4>***** ขอให้นักเรียนศึกษารายละเอียดต่างๆเกี่ยวกับการสมัครอย่างละเอียด เพื่อรักษาสิทธิในการสมัครสอบคัดเลือกนะคะ*****\n',
          '<h4>สามารถสอบถามข้อมูลเพิ่มเติมได้ที่ \n',
          '<h4>02-470-8386 , 8389 ในวันและเวลาราชการ \n',
          '<h1>หรือ Line Official :<a href="https://line.me/R/ti/p/%40316xtcrq" target="_blank">https://line.me/R/ti/p/%40316xtcrq</a>\n'
        ],
        imgSet: [
        ]
      },
      {
        newsId: 21,
        header: 'ประกาศรับสมัครนักเรียนเพื่อเข้าศึกษาประจำปีการศึกษา 2565',
        src: 'newsData/21/thumbnail.jpg',
        type: 'ประกาศ',
        data: 'notice',
        timeFormat: '30-07-2021',
        time: '30 ก.ค. 64',
        detail: '',
        headerImg: 'newsData/21/images.jpg',
        fullDetail: [
          '<h4>2022年度新入生募集 ประกาศรับสมัครนักเรียนเพื่อเข้าศึกษาประจำปีการศึกษา 2565\n',
          '<h4>สถาบันโคเซ็น มจธ. (KOSEN KMUTT)  เปิดรับสมัครนักเรียนระดับชั้นมัธยมศึกษาปีที่ ม.3 หรือเทียบเท่า\n',
          '<h4>เพื่อคัดเลือกเข้าเป็นนักเรียนในโครงการ KOSEN KMUTT ประจำปีการศึกษา 2565\n',
          '<h1>-หลักสูตร Automation Engineering รับ 48 คน\n',
          '<h1>- หลักสูตร Bio Engineering รับ 48 คน\n',
          '<h4>เปิดรับสมัครระหว่างวันที่ 1-31 สิงหาคม 2564\n',
          '<h1>สมัครออนไลน์ผ่านทางเว็ปไซต์ <a href="https://www.mwit.ac.th/" target="_blank">https://www.mwit.ac.th/</a>\n',
          '<h4>*** ขอให้นักเรียนศึกษารายละเอียดต่างๆเกี่ยวกับการสมัครอย่างละเอียด เพื่อรักษาสิทธิในการสมัครสอบคัดเลือกนะคะ*****\n',
          '<h4>สามารถสอบถามข้อมูลเพิ่มเติมได้ที่\n',
          '<h4>02-470-8386 , 8389 ในวันและเวลาราชการ\n',
          '<h1>หรือ Line Official : <a href="https://line.me/R/ti/p/%40316xtcrq" target="_blank">https://line.me/R/ti/p/%40316xtcrq</a>\n'
        ],
        imgSet: [
        ]
      },
      {
        newsId: 22,
        header: ' ประกาศผลการคัดเลือกนักเรียนชั้นมัธยมศึกษาปีที่ 5 (ชั้นปีที่ 2) เพื่อได้รับสิทธิ์ในการคัดเลือกและรับทุนการศึกษาต่อชั้นปีที่ 3-5 ณ สถาบันโคเซ็น ประเทศญี่ปุ่น',
        src: 'newsData/22/thumbnail.jpg',
        type: 'ประกาศ',
        data: 'notice',
        timeFormat: '1-09-2021',
        time: '1 ก.ย. 64',
        detail: '',
        headerImg: 'newsData/22/images.jpg',
        fullDetail: [
          '<h4>ประกาศผลการคัดเลือกนักเรียนชั้นมัธยมศึกษาปีที่ 5 (ชั้นปีที่ 2) เพื่อได้รับสิทธิ์ในการคัดเลือกและรับทุนการศึกษาต่อชั้นปีที่ 3-5\n',
          '<h4> ณ สถาบันโคเซ็น ประเทศญี่ปุ่น ประจำปีการศึกษา 2565\n',
          '<h4>2021年度日本高専編入校内選考結果発表\n',
          '<h1>合格おめでとうございました。\n',
          '<h1>รายละเอียด <a href="https://drive.google.com/file/d/1zdO87HHsCIx-5j73jF_b8tu3tLhGL-Ig/view?usp=sharing" target="_blank">ตามไฟล์ที่แนบมานี้</a>\n'
        ],
        imgSet: [
        ]
      },
      {
        newsId: 23,
        header: 'KOSEN KMUTT ประกาศรับสมัครอาจารย์สอนภาษาญี่ปุ่น จำนวน 2 ตำแหน่ง',
        src: 'newsData/14/thumbnail.jpg',
        type: 'ประกาศ',
        data: 'notice',
        timeFormat: '11-10-2021',
        time: '10 ต.ค. 64',
        detail: '',
        headerImg: 'newsData/14/images.jpg',
        fullDetail: [
          '<h4>KOSEN KMUTT ประกาศรับสมัครอาจารย์สอนภาษาญี่ปุ่น จำนวน 2 ตำแหน่ง\n',
          '<h4>-Senior Japanese Teacher จำนวน 1 ตำแหน่ง\n',
          '<h1>ปฏิบัติหน้าที่สอนรายวิชาภาษาญี่ปุ่น ณ มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรี บางขุนเทียน \n',
          '<h1>ส่งเอกสารประกอบการสมัครระหว่างวันที่ 11 ตุลาคม – 8 พฤศจิกายน 2564 \n',
          '<h1>รายละเอียดประกอบการรับสมัคร <a href="https://drive.google.com/file/d/19k6Om00yfmCZ1PUbeG6FrTipGB2JVbhW/view?usp=sharing" target="_blank">ตามไฟล์ที่แนบมานี้</a>\n',
          '<h4>日本語専任教師募集 勤務地　: キングモンクット・トンブリ工科大学のバーンクンティアン・キャンパス\n',
          '<h4>業務内容　: 高校生への日本語の指導（初～上級日本語レベル別）職種　: \n',
          '<h4>Senior Japanese Teacher 1名\n',
          '<h4>Junior Japanese Teacher 1名\n',
          '<h1>締め切り日　: 2021年10月11日〜11月8日 \n',
          '<h1>応募をご希望の方は、下の内容を読んでください。\n'
        ],
        imgSet: [
        ]
      },
      {
        newsId: 24,
        header: 'ประกาศ แก้ไขประกาศการสอบคัดเลือกนักเรียนชั้น ม.4 โครงการ วมว. ปีการศึกษา 2565',
        src: 'newsData/23/thumbnail.jpg',
        type: 'ประกาศ',
        data: 'notice',
        timeFormat: '11-10-2021',
        time: '5 ม.ค. 65',
        detail: '',
        headerImg: 'newsData/23/images.jpg',
        fullDetail: [
          '<h4>ตามที่กระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรมได้ประกาศเรื่อง\n',
          '<h4>การสอบคัดเลือกนักเรียนเข้าเป็นนักเรียนชั้นมัธยมศึกษาปีที่ 4  ใน\n',
          '<h1>“โครงการห้องเรียนวิทยาศาสตร์ในโรงเรียนโดยการกำกับดูแลของมหาวิทยาลัย ระยะที่ 3” \n',
          '<h1> ของกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม ประจำปีการศึกษา 2565 ประกาศ ณ วันที่ 23 กรกฎาคม 2564 นั้น\n',
          '<h4>เนื่องจากสถานการณ์การแพร่ระบาดของโรคติดเชื้อไวรัสโคโรนา 2019 (COVID-19)\n',
          '<h4>ในบางพื้นที่ยังมีผู้ติดเชื้อเป็นจำนวนมาก อีกทั้งสัดส่วนนักเรียนในระดับมัธยมศึกษาตอนต้นที่ได้รับวัคซีนป้องกันโรคติดเชื้อไวรัส โคโรนา 2019 (COVID-19) ยังอยู่ในระดับที่ไม่สูงมากนัก\n',
          '<h4>ดังนั้น เพื่อให้การดำเนินการสอบคัดเลือกในครั้งนี้เป็นไปด้วยความเรียบร้อย และเป็นไปตามมาตรการในการป้องกันการแพร่ระบาดของโรคติดเชื้อไวรัสโคโรนา 2019 (COVID-19)\n',
          '<h4> ที่ทางราชการกำหนด กระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม จึงขอแก้ไขประกาศการสอบคัดเลือกนักเรียนเข้าเป็นนักเรียนชั้นมัธยมศึกษาปีที่ 4  ใน “โครงการห้องเรียนวิทยาศาสตร์ในโรงเรียน โดยการกำกับดูแลของมหาวิทยาลัย ระยะที่ 3” ',
          '<h1>รายละเอียดเพิ่มเติม <a href= "http://scius.most.go.th/set/activity/view_detail/9/123" target="_blank">ตามลิงค์นี้</a>'
        ],
        imgSet: [
        ]
      },
      {
        newsId: 25,
        header: 'KOSEN KMUTT ประกาศรับสมัครอาจารย์สอนภาษาญี่ปุ่น จำนวน 2 ตำแหน่ง',
        src: 'newsData/25/thumbnail.jpg',
        type: 'ประกาศ',
        data: 'notice',
        timeFormat: '13-01-2021',
        time: '13 ม.ค. 65',
        detail: '',
        headerImg: 'newsData/25/images.jpg',
        fullDetail: [
          '<h1> 日本語専任教師募集\n',
          '<h4>勤務地 : キングモンクット工科大学トンブリ校 バーンクンティアンキャンパス\n',
          '<h4>業務内容 : 高専生への日本語の指導（初～上級日本語レベル別）\n',
          '<h4> 職種 : Senior Japanese Teacher 1名\n',
          '<h4>Junior Japanese Teacher 1名\n',
          '<h4>「キングモンクット工科大学トンブリ校のバーンクンティアン・キャンパスで高専生に日\n',
          '<h4>本語を指導します。応募締切は1月28日（金）です。 <a href= "https://drive.google.com/file/d/1tCCZd5foT8_xdU-Pgjz1if8oA52TtkLC/view?usp=sharing&fbclid=IwAR2He9pJXxErMnUg333uXM-tfvIiBAY8CV6Gdgf_6k5vdnYa52GElVMW6Q8" target="_blank">ตามลิงค์นี้</a>',
          '<h1> KOSEN KMUTT ประกาศรับสมัครอาจารย์สอนภาษาญี่ปุ่น จำนวน 2 ตำแหน่ง\n',
          '<h4>- Senior Japanese Teacher จำนวน 1 ตำแหน่ง\n',
          '<h4>- Junior Japanese Teacher จำนวน 1 ตำแหน่ง\n',
          '<h4> ปฏิบัติหน้าที่สอนรายวิชาภาษาญี่ปุ่น ณ มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรี บางขุนเทียน\n',
          '<h4>ส่งเอกสารประกอบการสมัครระหว่างวันที่ 13 มกราคม -28 มกราคม 2565\n',
          '<h4>รายละเอียดประกอบการรับสมัครตาม link ที่เเนบไว้ด้านบน\n'
        ],
        imgSet: [
        ]
      },
      {
        newsId: 26,
        header: 'ประกาศผลการคัดเลือก เรื่อง รายชื่อผู้ผ่านการสอบคัดเลือกนักเรียนเข้าเป็นนักเรียนชั้นมัธยมศึกษาปีที่ 4 โครงการ วมว. ประจำปีการศึกษา 2565 รอบแรก',
        src: 'newsData/26/thumbnail.jpg',
        type: 'ประกาศ',
        data: 'notice',
        timeFormat: '15-02-2022',
        time: '15 ก.พ. 65',
        detail: '',
        headerImg: 'newsData/26/images.jpg',
        fullDetail: [
          '<h2> ประกาศผลการคัดเลือก เรื่อง รายชื่อผู้ผ่านการสอบคัดเลือกนักเรียนเข้าเป็นนักเรียนชั้นมัธยมศึกษาปีที่ 4 โครงการ วมว. ประจำปีการศึกษา 2565', '<h2 style="color:rgb(255, 204, 0)"> รอบแรก \n',
          '<h4><a href= "https://drive.google.com/drive/folders/13HbnBtoOlDyQISfISo1S0SPIN6IcMQ_m?usp=sharing" target="_blank">ตามลิงค์นี้</a>',
          '<h4>โดยนักเรียนที่ผ่านการคัดเลือกและมีความประสงค์จะเข้าสอบคัดเลือกรอบสองในวันที่ 12 มีนาคม 2565 จะต้องดำเนินการ ดังนี้\n',
          '<h4>1. ยืนยันสิทธิ์และชำระค่าธรรมเนียมการสอบรอบสอง ในระหว่างวันที่ 2- 9 มีนาคม 2565\n',
          '<h4><a href= "https://www.kmutt.ac.th/GiftEd/view/th/education" target="_blank">คลิก</a>\n',
          '<h4>2. รายงานตัวและเข้าสอบคัดเลือกในวันที่ 12 มีนาคม 2565 ณ มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรี พื้นที่การศึกษาบางมด \n',
          '<h4>หมายเหตุ : ขอให้นักเรียนศึกษารายละเอียดในประกาศอย่างละเอียด เพื่อประโยชน์ของตัวนักเรียนเอง\n',
          '<h4>02-470-8386, 02-470-8389 \n',
          '<h4>หรือ Line ID : https://lin.ee/Bdks7nu \n'
        ],
        imgSet: [
        ]
      },
      {
        newsId: 27,
        header: 'ประกาศผลการคัดเลือก เรื่อง ผลการสอบคัดเลือกนักเรียนรอบแรกและกำหนดการสอบคัดเลือกนักเรียนรอบสองเพื่อเข้าเป็นนักศึกษาสถาบันโคเซ็นแห่งมหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรีชั้นปีที่ 1 ประจำปีการศึกษา 2565',
        src: 'newsData/27/thumbnail.jpg',
        type: 'ประกาศ',
        data: 'notice',
        timeFormat: '17-02-2022',
        time: '17 ก.พ. 65',
        detail: '',
        headerImg: 'newsData/27/images.jpg',
        fullDetail: [
          '<h2> ประกาศผลการคัดเลือก เรื่อง ผลการสอบคัดเลือกนักเรียนรอบแรกและกำหนดการสอบคัดเลือกนักเรียนรอบสองเพื่อเข้าเป็นนักศึกษาสถาบันโคเซ็นแห่งมหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรีชั้นปีที่ 1 ประจำปีการศึกษา 2565 \n',
          '<h4><a href= "https://drive.google.com/drive/folders/1-KdxDVyjy7vU99EePZvk0IR9MHrQp7M_?usp=sharing" target="_blank">ตามลิงค์นี้</a>',
          '<h4>โดยนักเรียนทีผ่านการคัดเลือกและมีความประสงค์จะเข้าสอบคัดเลือกรอบสองในวันที่ 20 มีนาคม 2565 จะต้องดำเนินการ ดังนี้\n',
          '<h4>1. ชำระค่าธรรมเนียมการสอบรอบสอง ในระหว่างวันที่ 11-15 มีนาคม 2565\n',
          '<h4><a href= "https://www.kmutt.ac.th/GiftEd/view/th/education" target="_blank">คลิก</a>\n',
          '<h4>2. รายงานตัวและเข้าสอบคัดเลือกในวันที่ 20 มีนาคม 2565 ณ มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรี พื้นที่การศึกษาบางมด  \n',
          '<h4>หมายเหตุ : ขอให้นักเรียนศึกษารายละเอียดในประกาศอย่างละเอียด เพื่อประโยชน์ของตัวนักเรียนเอง\n',
          '<h4>02-470-8386, 02-470-8389 \n',
          '<h4>หรือ Line ID : https://lin.ee/Bdks7nu \n'
        ],
        imgSet: [
        ]
      },
      {
        newsId: 28,
        header: 'นักเรียนที่ผ่านการคัดเลือกรอบที่ 1 โครงการ วมว ประจำปีการศึกษา 2565 และต้องการเข้าสอบคัดเลือกในวันที่ 12 มีนาคม 2565 จะต้องดำเนินการดังนี้',
        src: 'newsData/28/thumbnail.jpg',
        type: 'ประกาศ',
        data: 'notice',
        timeFormat: '2-03-2022',
        time: '2 มี.ค. 65',
        detail: '',
        headerImg: 'newsData/28/images.jpg',
        fullDetail: [
          '<font color="#FF0000"><h2>นักเรียนที่ผ่านการคัดเลือกรอบที่ 1 โครงการ วมว ประจำปีการศึกษา 2565 และต้องการเข้าสอบคัดเลือกในวันที่ 12 มีนาคม 2565 จะต้องดำเนินการดังนี้\n</font>',
          '<h2>1. ยืนยันสิทธิ์และทำการชำระค่าลงทะเบียนเข้าสอบรอบ 2 ได้ตั้งแต่วันที่ 2 -9 มีนาคม 2565 ผ่านทางธนาคารเท่านั้น หากพ้นกำหนดถือว่านักเรียนสละสิทธิ์การเข้าสอบ \n',
          '<h4><a href= "https://confirm-esc-551e3.web.app/" target="_blank"> ยืนยันสิทธิ์การเข้าสอบ </a>',
          '<h2>2. ตรวจหาเชื้อไวรัสโคโรนา 2019 (COVID - 19) ด้วยวิธีตรวจ ATK หรือวิธีอื่นที่มีความถูกต้องสูงกว่าระยะเวลาไม่เกิน 72 ชั่วโมงก่อนการสอบ และยื่นผลตรวจที่ยืนยันว่าไม่มีการติดเชื้อ ไวรัสโคโรนา 2019 (COVID - 19) ตามแบบฟอร์มที่กำหนด โดยนำมายื่นที่จุดลงทะเบียนในวันที่ 12 มีนาคม 2565  \n',
          '<h4><a href= "http://scius.most.go.th/upload/depositfiles/460/460.pdf" target="_blank">  แบบฟอร์ม   </a>',
          '<h4>แล้วพบกันในวันสอบค่ะ   \n',
          '<h4>“ทางสำนักงานฯ ไม่อนุญาติให้ชำระค่าธรรมเนียมการสอบในวันสอบนะคะ”\n',
          '<h4>สอบถามข้อมูลเพิ่มเติมได้ที่  \n',
          '<h4>โทร 02-4708386, 02-4708389 ได้ในวันและเวลาราชการ \n',
          '<h4>หรือ Line ID : https://lin.ee/Bdks7nu \n'
        ],
        imgSet: [
        ]
      },
      {
        newsId: 29,
        header: 'ประกาศเลขที่เลขที่นั่งสอบรอบ 2 โครงการ วมว.ประจำปีการศึกษา 2565 สอบคัดเลือกในวันที่ 12 มีนาคม 2565 ณ มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรี พื้นที่การศึกษาบางมด',
        src: 'newsData/29/thumbnail.jpg',
        type: 'ประกาศ',
        data: 'notice',
        timeFormat: '10-03-2022',
        time: '10 มี.ค. 65',
        detail: '',
        headerImg: 'newsData/29/images.jpg',
        fullDetail: [
          '<font color="#FF0000"><h2>นักเรียนที่มีสิทธิเข้าสอบ คือ นักเรียนที่ทำการยืนยันสิทธิ์ในระบบ และชำระค่าธรรมเนียมการสอบเป็นที่เรียบร้อยแล้ว (เปิดลงทะเบียนและชำระค่าธรรมเนียมการสอบระหว่างวันที่ 2-9 มีนาคม 2565)\n</font>',
          '<h4><a href= "https://docs.google.com/spreadsheets/d/192yb1nnaL2u7s2adtTbK-4eIVdDeG8RCYQoC5_aBF4A/edit?usp=sharing" target="_blank"> ประกาศเลขที่นั่งสอบ คลิ๊ก </a>',
          '<h4> ขอให้นักเรียนดูแลสุขภาพและหลีกเลี่ยงการไปในพื้นที่แออัด เพื่อประโยชน์ส่วนรวมนะคะ พบกันวันสอบค่ะ   \n',
          '<h4> รายละเอียดสอบถามเพิ่มเติมได้ที่  \n',
          '<h4>โทร 02-4708386, 02-4708389 ได้ในวันและเวลาราชการ \n',
          '<h4>หรือ Line ID : https://lin.ee/Bdks7nu \n'
        ],
        imgSet: [
        ]
      },
      {
        newsId: 30,
        header: 'นักเรียนที่ผ่านการคัดเลือกรอบที่ 1 โครงการ วมว ประจำปีการศึกษา 2565 และต้องการเข้าสอบคัดเลือกในวันที่ 12 มีนาคม 2565 จะต้องดำเนินการดังนี้',
        src: 'newsData/30/thumbnail.jpg',
        type: 'ประกาศ',
        data: 'notice',
        timeFormat: '11-03-2022',
        time: '11 มี.ค. 65',
        detail: '',
        headerImg: 'newsData/30/images.jpg',
        fullDetail: [
          '<font color="#FF0000"><h2>นักเรียนที่ผ่านการคัดเลือกรอบที่ 1 โครงการ KOSEN KMUTT ประจำปีการศึกษา 2565 และต้องการเข้าสอบคัดเลือกในวันที่ 20 มีนาคม 2565 จะต้องดำเนินการดังนี้\n</font>',
          '<h2>1. ยืนยันสิทธิ์และทำการชำระค่าลงทะเบียนเข้าสอบรอบ 2 ได้ตั้งแต่วันที่ 11 -15 มีนาคม 2565 ผ่านทางธนาคารเท่านั้น หากพ้นกำหนดถือว่านักเรียนสละสิทธิ์การเข้าสอบ \n',
          '<h4><a href= "https://esc.kmutt.ac.th/" target="_blank"> ยืนยันสิทธิ์การเข้าสอบ </a>',
          '<h4><a href= "https://drive.google.com/drive/folders/1HNAifa7KLwLpmGLiva07jAWnlCuEJHgo?usp=sharing" target="_blank">  ขั้นตอนการยืนยันสิทธิ์และชำระค่าธรรมเนียมการสอบ </a>',
          '<h2>2. ตรวจหาเชื้อไวรัสโคโรนา 2019 (COVID - 19) ทั้งนี้นักเรียนจะต้องคำเนินการ : ตรวจหาเชื้อไวรัสโคโรนา 2019 (COVID - 19) ด้วยวิธีตรวจ ATK หรือวิธีอื่นที่มีความถูกต้องสูงกว่า ในวันที่ 19 มีนาคม 2565 ตั้งแต่เวลา 09.00 น. เป็นต้นไป และยื่นผลตรวจที่ยืนยันว่าไม่มีการติดเชื้อ ไวรัสโคโรนา 2019 (COVID - 19) ตามแบบฟอร์มที่กำหนด โดยนำมายื่นที่จุดลงทะเบียนในวันที่ 20 มีนาคม 2565  \n',
          '<h4><a href= "https://drive.google.com/drive/folders/1Nmhrl9Dr1XBX_UWslrlHaZ77_2Oi7Qm2?usp=sharing" target="_blank">  แบบฟอร์ม   </a>',
          '<h4>แล้วพบกันในวันสอบค่ะ   \n',
          '<h4>“ทางสำนักงานฯ ไม่อนุญาติให้ชำระค่าธรรมเนียมการสอบในวันสอบนะคะ”\n',
          '<h4>สอบถามข้อมูลเพิ่มเติมได้ที่  \n',
          '<h4>โทร 02-4708386, 02-4708389 ได้ในวันและเวลาราชการ \n',
          '<h4>หรือ Line ID : https://lin.ee/Bdks7nu \n'
        ],
        imgSet: [
        ]
      },
      {
        newsId: 31,
        header: 'ประกาศสถาบันโคเซ็น มจธ. เรื่อง ผลการสอบคัดเลือกนักเรียนเพื่อเข้าเป็นนักศึกษาสถาบันโคเซ็นแห่งมหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรี ชั้นปีที่ 1 ประจำปีการศึกษา 2565',
        src: 'newsData/31/thumbnail.jpg',
        type: 'ประกาศ',
        data: 'notice',
        timeFormat: '05-04-2022',
        time: '5 เมษายน 65',
        detail: '',
        headerImg: 'newsData/31/images.png',
        fullDetail: [
          '<font color="#FF0000"><h2>ประกาศสถาบันโคเซ็น มจธ. เรื่อง ผลการสอบคัดเลือกนักเรียนเพื่อเข้าเป็นนักศึกษาสถาบันโคเซ็นแห่งมหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรี ชั้นปีที่ 1 ประจำปีการศึกษา 2565\n</font>',
          '<h2>ประกาศรายชื่อ\n',
          '<h4><a href= "https://drive.google.com/drive/folders/1sfCmlniaG3iMJDwEF7qY1lJtr0NyJn2-?usp=sharing" target="_blank"> https://drive.google.com/drive/folders/1sfCmlniaG3iMJDwEF7qY1lJtr0NyJn2-?usp=sharing </a>',
          '<font color="#FF0000"><h2>นักเรียนที่ได้รับการประกาศรายชื่อผู้ได้รับคัดเลือก ตัวจริง จะต้องรายงานตัวและยืนยันสิทธิ์  หรือสละสิทธิ์การเข้าศึกษาต่อประจำปีการศึกษา 2565 ระหว่างวันที่ 7-12 เมษายน 2565 ทาง \n</font>',
          '<h4><a href= "http://www.kmutt.ac.th/GiftEd/" target="_blank">  http://www.kmutt.ac.th/GiftEd/  </a> (หัวข้อการศึกษาต่อ) หรือ  <a href= "https://kosen-confirm.web.app/" target="_blank">   https://kosen-confirm.web.app/   </a>\n',
          '<font color="#FF0000"><h4>ทั้งนี้หากผู้ได้รับคัดเลือกตัวจริง ไม่ดำเนินการภายในวันที่ 12 เมษายน 2565 ถือว่าสละสิทธิ์การเข้าศึกษาต่อ ประจำปีการศึกษา 2565\n</font>',
          '<h4> รายละเอียดสอบถามเพิ่มเติมได้ที  \n',
          '<h4>โทร 02-4708386, 02-4708389 ได้ในวันและเวลาราชการ \n',
          '<h4>หรือ Line ID : https://lin.ee/Bdks7nu \n'
        ],
        imgSet: [
        ]
      },
      {
        newsId: 32,
        header: 'ประกาศสถาบันโคเซ็น มจธ. เรื่อง เปิดรับสมัครนักเรียนระดับชั้นมัธยมศึกษาปีที่ ม.3 หรือเทียบเท่าเพื่อคัดเลือกเข้าเป็นนักเรียนในโครงการ KOSEN KMUTT ประจำปีการศึกษา 2567',
        src: 'newsData/32/thumbnail.jpg',
        type: 'ประกาศ',
        data: 'notice',
        timeFormat: '05-08-2023',
        time: '5 สิงหาคม 66',
        detail: '',
        headerImg: 'newsData/32/images.png',
        fullDetail: [
          '<font color="#FF0000"><h2>ประกาศสถาบันโคเซ็น มจธ. เรื่อง เปิดรับสมัครนักเรียนระดับชั้นมัธยมศึกษาปีที่ ม.3 หรือเทียบเท่าเพื่อคัดเลือกเข้าเป็นนักเรียนในโครงการ KOSEN KMUTT ประจำปีการศึกษา 2567\n</font>',
          '<h2>เปิดรับสมัครระหว่างวันที่ 1-31 สิงหาคม 2566\n',
          '<h4>รายละเอียดการสมัครและประกาศรับสมัคร คลิก<a href= "https://mailkmuttacth-my.sharepoint.com/:b:/g/personal/teeranart_sut_kmutt_ac_th/EWWCi9-pyy9Mt93ghx035HgB1Lcn3K7qDX0Rj_t4oYxgUA?e=4ehNWf" target="_blank">  https://mailkmuttacth-my.sharepoint.com  </a> และ <a href= "https://drive.google.com/file/d/17D6NubevhKzYqX_KzqOFVFb0MU6pzyQ9/view?usp=sharing" target="_blank">   https://drive.google.com </a>\n',
          '<h4>ช่องทางการสมัครออนไลน์ คลิก<a href= "https://apply.mwit.ac.th/" target="_blank"> https://apply.mwit.ac.th/</a>',
          '<font color="#FF0000"><h2>ขอให้นักเรียนศึกษารายละเอียดต่างๆเกี่ยวกับการสมัครอย่างละเอียด เพื่อรักษาสิทธิในการสมัครสอบคัดเลือกนะคะ\n</font>',
          '<h4>FAQ : <a href= "https://bit.ly/3zUXXCU" target="_blank">  https://bit.ly/3zUXXCU </a>\n',
          '<h4> รายละเอียดสอบถามเพิ่มเติมได้ที  \n',
          '<h4>โทร 02-4708386, 02-4708389 ได้ในวันและเวลาราชการ \n',
          '<h4>หรือ Line ID <a href= "https://lin.ee/Bdks7nu" target="_blank">  https://lin.ee/Bdks7nu </a>\n'
        ],
        imgSet: [
        ]
      },
      {
        newsId: 33,
        header: 'ประกาศโครงการ วมว.(โรงเรียนดรุณสิกขาลัย)เรื่อง เปิดรับสมัครนักเรียนระดับชั้นมัธยมศึกษาปีที่ ม.3 หรือเทียบเท่าเพื่อคัดเลือกเข้าเป็นนักเรียนในโครงการจัดตั้งห้องเรียนวิทยาศาสตร์ในโรงเรียน โดยการกำกับดูแลของมหาวิทยาลัย (โครงการ วมว. ระยะที่ 3) ประจำปีการศึกษา 2567',
        src: 'newsData/33/thumbnail.jpg',
        type: 'ประกาศ',
        data: 'notice',
        timeFormat: '05-08-2023',
        time: '5 สิงหาคม 66',
        detail: '',
        headerImg: 'newsData/33/images.png',
        fullDetail: [
          '<font color="#FF0000"><h2>ประกาศโครงการ วมว.(โรงเรียนดรุณสิกขาลัย)เรื่อง เปิดรับสมัครนักเรียนระดับชั้นมัธยมศึกษาปีที่ ม.3 หรือเทียบเท่าเพื่อคัดเลือกเข้าเป็นนักเรียนในโครงการจัดตั้งห้องเรียนวิทยาศาสตร์ในโรงเรียน โดยการกำกับดูแลของมหาวิทยาลัย (โครงการ วมว. ระยะที่ 3) ประจำปีการศึกษา 2567\n</font>',
          '<h2>เปิดรับสมัครระหว่างวันที่ 1-31 สิงหาคม 2566\n',
          '<h4>รายละเอียดการสมัครและประกาศรับสมัคร คลิก<a href= "https://mailkmuttacth-my.sharepoint.com/:b:/g/personal/teeranart_sut_kmutt_ac_th/EQoaUI8BFcVIrJuUqSypQTYBuLqUcP60xDr_16owG_hZ_g?e=HxYNFw" target="_blank">  https://mailkmuttacth-my.sharepoint.com  </a> และ <a href= "https://drive.google.com/file/d/1Pe1FIMCmFfeZaxQ5FrdLP3sfLloR0xmy/view?usp=sharing" target="_blank">   https://drive.google.com </a>\n',
          '<h4>ช่องทางการสมัครออนไลน์ คลิก<a href= "https://apply.mwit.ac.th/" target="_blank"> https://apply.mwit.ac.th/</a>',
          '<font color="#FF0000"><h2>ขอให้นักเรียนศึกษารายละเอียดต่างๆเกี่ยวกับการสมัครอย่างละเอียด เพื่อรักษาสิทธิในการสมัครสอบคัดเลือกนะคะ\n</font>',
          '<h4>FAQ : <a href= "https://bit.ly/3zUXXCU" target="_blank">  https://bit.ly/3zUXXCU </a>\n',
          '<h4> รายละเอียดสอบถามเพิ่มเติมได้ที  \n',
          '<h4>โทร 02-4708386, 02-4708389 ได้ในวันและเวลาราชการ \n',
          '<h4>หรือ Line ID <a href= "https://lin.ee/Bdks7nu" target="_blank">  https://lin.ee/Bdks7nu </a>\n'
        ],
        imgSet: [
        ]
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/json/news/data.js